module.exports = __webpack_public_path__ + "static/media/fighter-jet.fc66f806.svg";